import { useState } from "react";
import { Trans, t } from "@lingui/macro";
export function ToastifyDebug(props) {
  const [open, setOpen] = useState(false);
  return (
    <div className="Toastify-debug">
      <span className="Toastify-debug-button" onClick={() => setOpen((old) => !old)}>
        {open ? t`Hide error` : t`Show error`}
      </span>
      {open && <div className="Toastify-debug-content">{props.children}</div>}
    </div>
  );
}
